import { isMobile } from './utils';
const id = '#wixMobileViewport';
const idContent = 'twism-meta-wix';
const idDivTwism = 'twism-div-white';
const style = `
  position: absolute;
  height: 100%;
  min-height: 100%;
  width: 100vw;
  transform: translateX(-${(window.outerWidth - window.innerWidth) / 2}px);
  background-color: #FFFFFF;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: calc(var(--above-all-z-index) - 4);
  transition: opacity 0.5s, margin-top 0.5s;
`;
const createDivBackgroundWebsiteWix = () => {
    const element = document.querySelector('#SITE_CONTAINER');
    const elementDivSelector = document.querySelector(`#${idDivTwism}`);
    const elementDiv = elementDivSelector || document.createElement('div');
    elementDiv.id = idDivTwism;
    elementDiv.style = style;
    if (!elementDivSelector)
        element.appendChild(elementDiv);
};
const removeDivBackgroundWebsiteWix = () => {
    const elementDiv = document.querySelector(`#${idDivTwism}`);
    if (elementDiv) {
        elementDiv.style = `
      ${style}
      transform: none;
    `;
        setTimeout(() => {
            elementDiv.style = `
        ${style}
        opacity: 0;
        margin-top: 50px;
        transform: none;
      `;
            setTimeout(() => {
                elementDiv.remove();
            }, 500);
        }, 350);
    }
};
export const setViewportMobileWix = () => {
    if (!isMobile())
        return;
    const item = document.querySelector(id);
    if (item) {
        setTimeout(() => {
            sessionStorage.setItem(idContent, item.content);
            createDivBackgroundWebsiteWix();
            item.content =
                'width=device-width, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no';
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        }, 620);
    }
};
export const removeViewportMobileWix = () => {
    if (!isMobile())
        return;
    const item = document.querySelector(id);
    if (item) {
        setTimeout(() => {
            item.content = sessionStorage.getItem(idContent);
            removeDivBackgroundWebsiteWix();
        }, 300);
    }
};
